// @mui
import { LoadingButton } from '@mui/lab';
import { Stack, Typography } from '@mui/material';

// components
import { Link } from 'react-router-dom';
import styles, { Icon } from "./styles.css";


export default function PasswordResetSuccess() {
  return (
    <>
     <Stack spacing={3} sx={styles.prs_stack} >
      <Stack  sx={{ my: 2, gap: "1.4rem" }}>
        <Icon
          alt="GWz check circle"
          src="/assets/icons/check-green-circle.svg"
          style={{ pointerEvents: 'none' }}
        />
        <Typography variant="h4" 
          whiteSpace={"pre-line"}
          sx={styles.t_email_sent}>SUCCESSFUL{"\n"} PASSWORD RESET!</Typography>
        <Typography variant="body1" 
          sx={styles.fss_t_description}>You can now use your new password to login to your account.</Typography>
      </Stack>

      <Link to="/login">
        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          sx={{
              background: "linear-gradient(90deg, #501794 0%, #3E70A1 100%)",
              color: "white",
              borderRadius: "10px",
              textTransform: "none",
              "&:hover": {
                background: "linear-gradient(90deg, #3E70A1 0%, #501794 100%)",
              },
            }}
        >
          Back to Sign In
        </LoadingButton>
      </Link>
    </Stack>
    </>
  );
}
